// No number field in the panel takes a negative value, so one guard covers every <input type="number">,
// including ones added later. A field that really needs a negative can opt out with data-allow-negative
// or an explicit negative min.
//   - min defaults to 0, so the spinner arrows and the arrow keys stop at 0
//   - "-", "+" and "e" cannot be typed or pasted
//   - a negative that still gets in (drag and drop, autofill) is set to 0
const isNumberInput = (el) => el instanceof HTMLInputElement && el.type === 'number';
const allowsNegative = (el) => el.hasAttribute('data-allow-negative') || (el.min !== '' && Number(el.min) < 0);

// React controlled inputs only notice a value change made through the native setter plus an input event
const setValue = (el, value) => {
  const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
  setter.call(el, value);
  el.dispatchEvent(new Event('input', { bubbles: true }));
};

export function installNumberGuard() {
  if (typeof document === 'undefined' || window.__numberGuardInstalled) return;
  window.__numberGuardInstalled = true;

  const ensureMin = (el) => {
    if (isNumberInput(el) && el.min === '' && !allowsNegative(el)) el.min = '0';
  };

  document.addEventListener('focusin', (e) => ensureMin(e.target), true);
  document.addEventListener('pointerdown', (e) => ensureMin(e.target), true);

  document.addEventListener('keydown', (e) => {
    const el = e.target;
    if (!isNumberInput(el) || allowsNegative(el) || e.ctrlKey || e.metaKey || e.altKey) return;
    if (['-', '+', 'e', 'E'].includes(e.key)) e.preventDefault();
  }, true);

  document.addEventListener('paste', (e) => {
    const el = e.target;
    if (!isNumberInput(el) || allowsNegative(el)) return;
    const text = (e.clipboardData && e.clipboardData.getData('text')) || '';
    if (/[-+eE]/.test(text)) e.preventDefault();
  }, true);

  let busy = false;
  document.addEventListener('input', (e) => {
    const el = e.target;
    if (busy || !isNumberInput(el) || allowsNegative(el)) return;
    if (el.value !== '' && Number(el.value) < 0) {
      busy = true;
      try { setValue(el, '0'); } finally { busy = false; }
    }
  }, true);
}
